import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Heading from '../../heading';
import Paragraph from '../../paragraph';
import TextSkeleton from '../../skeletons/text-skeleton';

const PlanPricing = ({
  first = '',
  second = '',
  period = '',
  isLoading = false,
  withExtraPrice = false,
}) => {
  const classes = classNames('ws-ui-plan-pricing', {
    'ws-ui-plan-pricing--is-loading': isLoading,
  });
  const mediaQuery = '(min-width: 992px) and (max-width: 1280px)';
  const mediaWatcherRef = useRef(window.matchMedia(mediaQuery));
  const mediaWatcher = mediaWatcherRef.current;
  const [headingType, setHeadingType] = useState(mediaWatcher.matches ? 'heading-3' : 'heading-2');

  useEffect(() => {
    function updateHeadingType(e) {
      setHeadingType(e.matches ? 'heading-3' : 'heading-2');
    }
    mediaWatcher.addEventListener('change', updateHeadingType);
    return function cleanup() {
      mediaWatcher.removeEventListener('change', updateHeadingType);
    };
  }, [mediaWatcher]);

  return (
    <div className={classes}>
      <div className="ws-ui-plan-pricing__first-part">
        <Heading type={headingType} appearance={withExtraPrice ? 'cta' : 'default'}>
          {isLoading ? <TextSkeleton width="170px" centered /> : first}
        </Heading>
      </div>
      {!isLoading && (
        <div className="ws-ui-plan-pricing__second-part">
          <Paragraph appearance={withExtraPrice ? 'cta' : 'medium-emphasis'} size="small">
            {second}
          </Paragraph>
          <Paragraph appearance={withExtraPrice ? 'cta' : 'medium-emphasis'} size="small">
            {period}
          </Paragraph>
        </div>
      )}
    </div>
  );
};

PlanPricing.propTypes = {
  first: PropTypes.string,
  second: PropTypes.string,
  period: PropTypes.string,
  isLoading: PropTypes.bool,
  withExtraPrice: PropTypes.bool,
};

export default PlanPricing;
